module.exports = __webpack_public_path__ + "static/media/MTL_SL_IRON3.b2a385aa.png";